module.exports = __webpack_public_path__ + "img/work4-1.632e06c6.png";